import classnames from 'classnames';
import { FC, memo } from 'react';

import { Skeleton } from '@gem/ui-kit';

import styles from './TextPlaceholder.styles.m.css';

interface ITextPlaceholderProps {
  className?: string;
  width?: number;
  duration?: number;
}

export const TextPlaceholder: FC<ITextPlaceholderProps> = memo((props) => {
  const { className, width = 100, duration = 1000 } = props;

  return (
    <Skeleton
      animationConfig={{ duration }}
      width={`${width}px`}
      className={classnames(styles.container, className)}
    />
  );
});
